<template>
    <div>

        <h3 class="text-center mb-4 d-print-none"><strong>Project Journal Menu</strong></h3>

        <project-journal-table/>

    </div>
</template>

<script>
    import ProjectJournalTable from "@/components/warboard/ProjectJournal/ProjectJournalTable";

    export default {
        name: "ProjectJournalHome",
        components: { ProjectJournalTable }
    }
</script>

<style scoped>

</style>